document.addEventListener("DOMContentLoaded", function() {

  const recommendationProductItemList = document.querySelectorAll('.shoppable-recommendation-product-item')
  const shoppableGraphicBullets = document.querySelectorAll('[data-shoppable-graphic-bullet-item]')

  function activeHover(bulletItem) {
    // Active tooltip
    const bulletProduct = bulletItem.querySelector('[data-shoppable-graphic-bullet-product]')
    bulletProduct && bulletProduct.classList.add('active')
    // Active recommended product
    const hoveredProductID = parseInt(bulletItem.getAttribute('data-shoppable-graphic-bullet-item'))
    hoveredProductID && recommendationProductItemList && recommendationProductItemList.forEach(recommendationProductItem => {
      const recommendationProductId = parseInt(recommendationProductItem?.getAttribute('data-product-id'))
      if (recommendationProductId && recommendationProductId === hoveredProductID) recommendationProductItem?.classList.add('active')
    })
  }

  function deactivateHover(bulletItem) {
    // Deactivate Tooltip
    const bulletProduct = bulletItem.querySelector('[data-shoppable-graphic-bullet-product]')
    bulletProduct && bulletProduct.classList.remove('active')
    // Deactivate recommended product
    recommendationProductItemList && recommendationProductItemList.forEach(recommendationProductItem => {
      recommendationProductItem && recommendationProductItem.classList.remove('active')
    })
  }

  function initGraphicBullets(bullets) {
    bullets.forEach(bulletItem => {
      bulletItem && bulletItem.addEventListener('mouseover', function() {
        activeHover(bulletItem)
      })
      bulletItem && bulletItem.addEventListener('mouseout', function() {
        deactivateHover(bulletItem)
      })
    })
  }

  if (shoppableGraphicBullets) initGraphicBullets(shoppableGraphicBullets)

})